import React from 'react';
import { Box, Chip, Tooltip } from '@mui/material';

export interface ConversationContactTagBrief {
  id: string;
  name: string;
  color: string | null;
}

const MAX_VISIBLE = 4;

interface ConversationListContactTagsProps {
  tags?: ConversationContactTagBrief[] | null;
  /** compact = ao lado da hora; row = abaixo da prévia (lista estilo WhatsApp Web) */
  variant?: 'compact' | 'row';
}

function tagPillSx(name: string, color: string | null) {
  const base = color || '#64748b';
  const lower = name.toLowerCase();
  let bg = `${base}18`;
  let text = base;
  let border = `${base}40`;

  if (lower.includes('urgent') || lower.includes('urgente')) {
    bg = '#fef2f2';
    text = '#b91c1c';
    border = '#fecaca';
  } else if (lower.includes('retorno') || lower.includes('confirm')) {
    bg = '#ecfdf3';
    text = '#15803d';
    border = '#bbf7d0';
  } else if (lower.includes('lead') || lower.includes('novo')) {
    bg = '#f1f5f9';
    text = '#475569';
    border = '#e2e8f0';
  } else if (lower.includes('particular') || lower.includes('plano')) {
    bg = '#eff6ff';
    text = '#1d4ed8';
    border = '#bfdbfe';
  }

  return {
    height: 20,
    maxWidth: 110,
    bgcolor: bg,
    color: text,
    border: `1px solid ${border}`,
    fontWeight: 600,
    '& .MuiChip-label': {
      px: 0.75,
      fontSize: '0.65rem',
      lineHeight: 1.2,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
  };
}

export default function ConversationListContactTags({
  tags,
  variant = 'compact',
}: ConversationListContactTagsProps) {
  if (!tags?.length) return null;

  const visible = tags.slice(0, MAX_VISIBLE);
  const rest = tags.length - visible.length;

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 0.5,
        flexWrap: 'wrap',
        justifyContent: variant === 'row' ? 'flex-start' : 'flex-end',
        maxWidth: variant === 'row' ? '100%' : { xs: 160, sm: 200 },
        mt: variant === 'row' ? 0 : undefined,
      }}
    >
      {visible.map((t) => (
        <Tooltip key={t.id} title={t.name}>
          <Chip label={t.name} size="small" sx={tagPillSx(t.name, t.color)} />
        </Tooltip>
      ))}
      {rest > 0 ? (
        <Chip
          label={`+${rest}`}
          size="small"
          sx={{
            height: 20,
            bgcolor: '#f1f5f9',
            color: '#64748b',
            border: '1px solid #e2e8f0',
            '& .MuiChip-label': { px: 0.5, fontSize: '0.65rem', fontWeight: 600 },
          }}
        />
      ) : null}
    </Box>
  );
}
